import React from "react";
import { FaEdit, FaTrash } from "react-icons/fa";
import "../../pages/Machine.css";

const MachineTable = ({ machines, onEdit, onDelete }) => {
  if (!machines || machines.length === 0) {
    return (
      <div className="table-container">
        <table className="table">
          <thead>
            <tr>
              <th>Machine ID</th>
              <th>Machine Name</th>
              <th>Description</th>
              <th>Status</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td colSpan="5" style={{ textAlign: "center" }}>
                No machines found.
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    );
  }

  return (
    <div className="table-container">
      <table className="table">
        <thead>
          <tr>
            <th>Machine ID</th>
            <th>Machine Name</th>
            <th>Description</th>
            <th>Status</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {machines.map((machine, index) => (
            <tr key={index}>
              <td>{machine.machine_id}</td>
              <td>{machine.machine_name}</td>
              <td>{machine.description}</td>
              <td>
                <span
                  className={`status ${machine.is_active ? "active" : "inactive"}`}
                >
                  {machine.is_active ? "Active" : "Inactive"}
                </span>
              </td>
              <td>
                <button
                  className="btn btn-secondary btn-sm"
                  onClick={() => onEdit(machine)}
                >
                  <FaEdit />                
                   </button>
                <button
                  className="btn btn-danger btn-sm"
                  onClick={() => onDelete(machine)}
                  style={{ marginLeft: "5px" }}
                >
                  <FaTrash /> 
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default MachineTable;